<template>
    <div class="input__container">
        <p v-if="title">{{ title }}</p>
        <select
            required 
            :value="modelValue" 
            @input="selectCurrentItem($event)" 
            :disabled="disabled"
        >
            <option value="" disabled selected hidden>{{ placeholder }}</option>
            <option v-for="(item, index) in items" :value="item.key">{{ item.value }}</option>
        </select>
        <span v-if="error">{{ error }}</span>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            items: Array,
            modelValue: String,
            placeholder: String,
            disabled: Boolean,
            title: String,
            error: String,
        },
        emits: ['update:modelValue', 'itemSelected'],
        methods: {
            selectCurrentItem(e) {
                this.$emit('update:modelValue', e.target.value)
                this.$emit('itemSelected', e.target.value)
            }
        }
    }
</script>

<style lang="scss" scoped>
.input__container {
    position: relative;
    display: flex;
    flex-direction: column;

    select {
        width: 100%;
        appearance: none;
    }
}

</style>